import React from 'react';
import CrmSettingsPage from '../components/CrmSettingsPage';

const CrmSettingsApp = (props) => (
  <CrmSettingsPage {...props} />
);

export default CrmSettingsApp;
